// extracted by mini-css-extract-plugin
module.exports = {"page_header":"FullDealAndPing3OffersPage_page_header__jH3iA"};